module.exports = __webpack_public_path__ + "img/xwzx_card.93d1d7d4.png";